import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Logo } from '@grandvisionhq/common';
import NavigationContainer from '../Navigation/NavigationContainer.js';

const Header = (_param)=> {
    var { className , logo , isMobile , hasNavigation =true , title , srOnlyText  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "logo",
        "isMobile",
        "hasNavigation",
        "title",
        "srOnlyText"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('book-appointment-header', className)
    }), /*#__PURE__*/ React.createElement("header", {
        className: classnames('book-appointment-header__header', {
            'book-appointment-header__header--has-only-logo': !hasNavigation
        })
    }, logo && /*#__PURE__*/ React.createElement(Logo, {
        className: "book-appointment-header__logo",
        url: "/",
        image: logo,
        title: title,
        srOnlyText: `, ${srOnlyText}`
    }), hasNavigation && /*#__PURE__*/ React.createElement(NavigationContainer, {
        className: "book-appointment-header__navigation"
    })));
};

export { Header as default };
//# sourceMappingURL=Header.js.map
